<template>
    <div>
        <div class="splash-screen">
            <header class="container app-header" style="background-image: url('/img/bg-header.png'); height: 30px;">
            <img class="header-icon" src="/img/logo-header.png" alt=""/>
            <h1 style="font-size: 12px;">Sistema de Información Geográfico</h1>
            </header>
            <section>
                <div>
                    <div class="columna3">
                        <img v-if="MsgIconClass=='message-icon-error' ? true : false" class="message-icon" src="/img/img-error.jpg"/>
                        <img v-if="MsgIconClass=='message-icon-alert' ? true : false" class="message-icon" src="/img/img-alert.png"/>
                        <img v-if="MsgIconClass=='message-icon-check' ? true : false" class="message-icon" src="/img/img-check.png"/>                    </div>
                    <div class="columna4">
                        <h1 class="subtitulo">
                            <strong style="margin-top: 5px;">{{msgTitulo}}</strong>
                        </h1>
                        <small class="subtitulo">
                            <span clas="clsli" v-for="(line,i) in MsgSubTitulo.split('\n')" :key="i">{{line}}</span>
                        </small>
                    </div>
                </div> 
            </section>
            <footer class="footer">
                <button class="btn btn-primary" @click="closeSplashScreen">Aceptar</button>
            </footer>
        </div>
        <div class="sombra"></div>
    </div>

</template>

<script>
    const config = splash_config;
    export default {
        name: "MessageScreen",
        props: {
            msgTitulo: '',
            MsgSubTitulo: '',
            MsgIconClass:''
        },
   
        watch: {
            msgTitulo(nuevoValor, antiguo){
                this.iconError = nuevoValor=='message-icon-error' ? true : false; 
                this.iconAlert = !this.iconError;
            },
        },    
        data(){
            return {
                iconError:true,
                iconAlert:false,
            }
        },              
        methods:{
            closeSplashScreen(){
                this.$emit('close');
            },
        }
    }
</script>

<style scoped>
    .splash-screen {
        padding: 0;
        background-color: white;
        width: 30%;
     }
     
    .splash-screen .subtitulo {
        font-weight: unset;
        text-align: left;
        font-size: 1em;
    } 

    #app .app-header .header-icon {
     margin-left: 5px;
    }
    .columna3 {
        width:23.5%;
        float:left;
        margin-right: 0.5em;
    }
    .columna4 {
        width:74.5%;
        float:left;
        margin-right: 0;
    }
    .message-icon{
        width: 50px;
        margin-left: 25px;
        margin-top: 20px;
    }
    .footer{
        margin-bottom: 20px; 
    }
  .clsli{        
        margin-bottom: 0.5em; 
    }
  .clsli:last-child{
        margin-bottom: 0;
    }    
</style>